import React, { useState, useEffect } from 'react';
// import Axios from 'axios'
import { CATviewWrapper } from '../CATviewWrapper/CATviewWrapper';
import { runQuery, sigmoid } from '../utils'
import { getBlocks, getNgramMatches } from './queries'
import { Spinner } from '../Spinner/Spinner';
import { Surface3Wrapper } from '../Surface3Wrapper';
import { TextView } from '../TextView/TextView';


export interface MyComponentProps {
  // Define your prop types here
  expressionid: string,
  expressionConstraint?: string
}

export const CATviewNgrams: React.FC<MyComponentProps> = (props) => {

  const [edges, setEdges] = useState<any[]>([])
  const [edgeNames, setEdgeNames] = useState<any[]>([])
  const [edgeCts, setEdgeCts] = useState<any[]>([])
  const [witNames, setWitNames] = useState<any[]>([])
  const [witCts, setWitCts] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  //const [displayText, setDisplayText] = useState<string>("")
  const [focusBlockTid, setFocusBlockTid] = useState<string>("")
  const [focusBlockEid, setFocusBlockEid] = useState<string>("")
  const [focusCompareTid, setFocusCompareTid] = useState<string>("")
  const [focusCompareEid, setFocusCompareEid] = useState<string>("")
  const [limit, setLimit] = useState<number>(1500)
  const [offset, setOffset] = useState<number>(0)


  useEffect(() => {
    getNgramInfo()
  }, [props.expressionid, offset])


  const handleOnClick = (wit: any, edge: any) => {
    const blockid: string = edgeNames[edge]
    const blockTid: string = edgeCts[edge]
    const compareid: string = witNames[wit - 1]
    const compareTid: string = witCts[compareid]
    setFocusBlockTid(blockTid)
    setFocusCompareTid(compareTid)
    setFocusBlockEid(blockid)
    setFocusCompareEid(compareid)
    //setDisplayText("blockid: " + blockid + " compareid: " + compareid)
  }

  const getNgramInfo = () => {
    setLoading(true)
    const sparqlEndpoint = "https://ngram.scta.info/ds/query"
    const query1: string = getBlocks(props.expressionid, limit, offset)
    runQuery(query1, sparqlEndpoint).then((d: any) => {
      const startBlockItemHash: any = {}
      const blocks: any[] = d.data.results.bindings.map((i: any) => {
        startBlockItemHash[i.block.value] = i.blockItem.value
        return i.block.value
      })
      const blocksct: any[] = d.data.results.bindings.map((i: any) => {
        return i.bct.value
      })
      const values: any[] = d.data.results.bindings.map((i: any) => {
        return "<" + i.block.value + ">"
      }).join(" ")

      const startAuthorBirthDate = d.data.results.bindings[0]?.startAuthorBirthDate?.value

      runQuery(getNgramMatches(values, 4, props.expressionConstraint), sparqlEndpoint, "post").then((d: any) => {
        const results: any[] = d.data.results.bindings

        // BEGIN re-arrange maneuver to put all texts without author dates at the bottom of the matrix
        const indexOfFirstAuthorDate = results.findIndex((r) => {
          return r.authorBirthDate
        })
        const firstPart: any = results.slice(0, indexOfFirstAuthorDate)
        const restPart: any = results.slice(indexOfFirstAuthorDate)
        const sortedResults = restPart.concat(firstPart)
        // END re-arrange maneuver

        const relationHash: any = {}
        const targetBlockItemHash: any = {}
        // a hash that contains the corresponding author date for any given row
        const authorBirthDate: any = {}
        const witCtsHash: any = {}
        sortedResults.forEach((sr: any) => {
          relationHash[sr.start.value + "===" + sr.target.value] = sigmoid(sr.count.value)
          targetBlockItemHash[sr.target.value] = sr.targetItem && sr.targetItem.value
          authorBirthDate[sr.target.value] = sr.authorBirthDate ? sr.authorBirthDate.value : "1800" //  adding 1800 here to force texts without author dates to show up blue
          witCtsHash[sr.target.value] = sr.cct.value
        })
        
        const witNamesWithDups: any[] = sortedResults.map((r: any) => {
          return r.target.value
        })
        const witNames = Array.from(new Set(witNamesWithDups));

        // const clusters = []
        let edgesArray: any[] = []
        blocks.forEach((b: string) => {
          let edge: any[] = []
          witNames.forEach((w: string) => {

            //const score = (relationHash[b + "===" + w]) ? relationHash[b + "===" + w]*4 : -1

            // below is alt socre mode used to set score to visualize authors before and after
            // but it loses is degree of variation, because variation is now used to communicate before and after date 

            let score = -1
            if (relationHash[b + "===" + w]) {
              if (authorBirthDate[w] > startAuthorBirthDate) {
                score = 1

              }
              else if (authorBirthDate[w] < startAuthorBirthDate) {
                score = 0.25
              }
              else if (authorBirthDate[w] === startAuthorBirthDate) {
                score = 0.25
              }
              else {
                score = .15
              }
            }




            //   //console.log('idx0 and edges', idx0, edges)
            //   //if (idx0 > 1 && idx > 1){
            //     const rowThis = edge
            //     const rowThisCellPrev = edge[idx - 1]
            //     const rowThisCell2Prev = edge[idx - 2]
            //     const rowThisCell3Prev = edge[idx - 3]
            //     const rowThisCell4Prev = edge[idx - 4]
            //     const rowPrev = edges[idx0 - 1]
            //     const rowPrevCellPrev = rowPrev && rowPrev[idx - 1]
            //     const rowPrevCell2Prev = rowPrev && rowPrev[idx - 2]
            //     const rowPrevCell3Prev = rowPrev && rowPrev[idx - 3]
            //     const rowPrevCell4Prev = rowPrev && rowPrev[idx - 4]
            //     const row2Prev = edges[idx0 - 2]
            //     const row2PrevCellPrev = rowPrev && rowPrev[idx - 1]
            //     const row2PrevCell2Prev = rowPrev && rowPrev[idx - 2]
            //     const row2PrevCell3Prev = rowPrev && rowPrev[idx - 3]
            //     const row2PrevCell4Prev = rowPrev && rowPrev[idx - 4]

            //   if (edges[idx0 - 1] 
            //   && rowThisCellPrev && rowThisCell2Prev && rowThisCell3Prev & rowThisCell4Prev 
            //   && rowPrevCellPrev && rowPrevCell2Prev && rowPrevCell3Prev & rowPrevCell4Prev 
            //   && row2PrevCellPrev && row2PrevCell2Prev && row2PrevCell3Prev & row2PrevCell4Prev) {

            //     // const rowPrev = edges[idx0 - 1]
            //     // const rowPrevCellPrev = rowPrev[idx - 1]
            //     // const rowPrevCell2Prev = rowPrev[idx - 2]
            //     // const rowPrevCell3Prev = rowPrev[idx - 3]
            //     // const rowPrevCell4Prev = rowPrev[idx - 4]
            //     // const row2Prev = edges[idx0 - 2]
            //     // const row2PrevCellPrev = rowPrev[idx - 1]
            //     // const row2PrevCell2Prev = rowPrev[idx - 2]
            //     // const row2PrevCell3Prev = rowPrev[idx - 3]
            //     // const row2PrevCell4Prev = rowPrev[idx - 4]

            //     //if (score != -1 && rowPrevCellPrev != -1  && row2PrevCellPrev != - 1){
            //       if (score !== -1 && 
            //       (rowThisCellPrev !== -1 || rowThisCell2Prev !== -1 || rowThisCell3Prev !== -1 ||  rowThisCell4Prev !== -1)
            //       ||
            //       (rowPrevCellPrev !== -1 || rowPrevCell2Prev !== -1 || rowPrevCell3Prev !== -1 ||  rowPrevCell4Prev !== -1)
            //       ||
            //       (row2PrevCellPrev !== -1 || row2PrevCell2Prev !== -1 || row2PrevCell3Prev !== -1 ||  row2PrevCell4Prev !== -1)
            //       ){
            //       console.log(edges[idx0 - 1][idx - 1])
            //       //console.log(edges[idx0 - 2][idx - 2])
            //       clusters.push(b + "===" + w)
            //     }
            // }

            edge.push(score)
          })
          edge.unshift(0);
          edgesArray.push(edge)
        })
        setEdges(edgesArray)
        setWitNames(witNames)
        setWitCts(witCtsHash)
        setEdgeNames(blocks)
        setEdgeCts(blocksct) // this is here to canonical transcription ids
        setLoading(false)
      })
    })
  }

  return (
    <div>
    {loading 
    ? 
    <Spinner/> :
    <>
    {offset !== 0 && <span className="lbp-span-link" onClick={() => setOffset(offset - limit)}>Previous</span>}
    {<span className="lbp-span-link" onClick={() => setOffset(offset + limit)}>Next</span>}

    <CATviewWrapper edges={edges} names={["start", ...witNames]} edgeNames={edgeNames} height={"50vh"} showWitNames={false} parentHandleOnClick={handleOnClick} colorScale={["#FF0000", "#0000FF", "#000000"]}/>
    <div>
    {focusBlockTid && 
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <div style={{width: "45%"}}>{focusBlockTid}<TextView tresourceid={focusBlockTid} compareTresourceid={focusCompareTid}/></div>
        <div style={{width: "45%"}}>{focusCompareTid} <TextView tresourceid={focusCompareTid} compareTresourceid={focusBlockTid}/></div>
      </div>
    }
    {focusCompareTid && 
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <div style={{width: "45%"}}><Surface3Wrapper expressionid={focusBlockEid} hideCustomImageForm={true}/></div>
        <div style={{width: "45%"}}><Surface3Wrapper expressionid={focusCompareEid} hideCustomImageForm={true}/></div>
      </div>
    }
    </div>
    </>
    }
    
    </div>
  )


}
